import { ModalTypes } from '@/helper/ModalTypes'

export default class ModalParams<T> {
  constructor(public readonly modalType: ModalTypes, public readonly payload?: T) {
  }
}
